import { format } from "date-fns";
import * as locales from 'date-fns/locale';
import i18next from "i18next";
import { Column } from "../objects/column";
import { OrganisationComment } from "../objects/organisationComment";
import { OrganisationContact } from "../objects/organisationContact";
import { OrganisationContactListField } from "../objects/organisationContactListField";
import { OrganisationHistTrip } from "../objects/organisationHistTrip";
import { OrganisationNote } from "../objects/organisationNote";
import { OrganisationRubricConfiguration } from "../objects/organisationRubricConfiguration";
import { OrganisationRubricsItemInterface } from "../objects/organisationRubricsItemInterface";
import { OrganisationSubNetworkListField } from "../objects/organisationSubNetworkListField";
import { OrganisationTripListConfiguration } from "../objects/organisationTripListConfiguration";
import { OrganisationTripListCriteria } from "../objects/organisationTripListCriteria";
import { OrganisationTripListFiltersCriteria } from "../objects/organisationTripListFiltersCriteria";
import { BEACHCOMBER_COLUMN, CDV_COLUMN, DEFAULT_COLUMN, MCI_COLUMN, MV_COLUMN } from "./organisationColumn";
import { OrganisationContactErrors } from "../objects/organisationContactErrors";


export const HTTP_HEADER = {
    'Authorization': `Token ${localStorage.getItem('token')}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': 'fr'
};

export const ORGANISATION_COLUMNS: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'total-trips',
    field_name: 'TOTAL_TRIPS',
    checked: true,
    order_by: 'total_trips',
    fixed_width: false,
    last_updated: false
}, {
    label: 'network',
    field_name: 'NETWORK',
    checked: true,
    order_by: 'group_minimal__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'sub-network-agency',
    field_name: 'SUB_NETWORK',
    checked: true,
    order_by: 'sub_net__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'mini-network',
    field_name: 'MINI_NETWORK',
    checked: true,
    order_by: 'mini_network__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false,
    width: null
}];
export const ORGANISATION_COLUMNS_VA: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'total-trips',
    field_name: 'TOTAL_TRIPS',
    checked: true,
    order_by: 'total_trips',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'brands',
    field_name: 'BRANDS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const ORGANISATION_RUBRICS: OrganisationRubricsItemInterface[] = [
    {
        id: 0,
        checked: true,
        field_name: "informations",
    }, {
        id: 1,
        checked: true,
        field_name: "info-compta",
    }, {
        id: 2,
        checked: true,
        field_name: "info-network",
    },
    {
        id: 3,
        checked: false,
        field_name: "commission",
    },
    {
        id: 4,
        checked: true,
        field_name: "communication-permission",
    }, {
        id: 5,
        checked: true,
        field_name: "contacts",
    }, {
        id: 6,
        checked: true,
        field_name: "markets",
    },
    {
        id: 7,
        checked: true,
        field_name: "payment-type-management",
    },
    {
        id: 8,
        checked: true,
        field_name: "attachments",
    },
];

export const EMPTY_ORGANISATION_RUBRICS_CONFIGURATION: OrganisationRubricConfiguration = {
    columns: ORGANISATION_RUBRICS,
    preferences: []
};

export const EMPTY_ORGANISATION_CONTACT: OrganisationContact = {
    id: -1,
    created_date: new Date(),
    modified_date: new Date,
    first_name: '',
    last_name: '',
    contact_email: '',
    phone_number: '',
    creator: null,
    last_author: null,
    parent: undefined,
    is_detailed: undefined,
    role: ""
};
export const EMPTY_ORGANISATION_CONTACT_ERROR: OrganisationContactErrors = {
    first_name_error: '',
    last_name_error: '',
    contact_email_error: '',
    phone_number_error: '',
    role_error: ""
};
export const EMPTY_ORGANISATION_NOTE: OrganisationNote = {
    id: -1,
    created_date: new Date(),
    modified_date: new Date,
    note: '',
    creator: null,
    last_author: null,
    parent: undefined,
    is_comment: false,
    is_detailed: false
};

export const EMPTY_ORGANISATION_COMMENT: OrganisationComment = {
    id: -1,
    created_date: new Date(),
    modified_date: new Date,
    note: '',
    creator: null,
    last_author: null,
    parent: undefined,
    is_comment: true,
    is_detailed: false
};

export const CONTACT_LIST_FIELD: OrganisationContactListField[] = [
    {
        field_name: "name",
        label: "name",
        sortable: true,
        getValue: (contact) => `${contact.first_name} ${contact.last_name}`,
    },
    {
        field_name: "role",
        label: "role",
        sortable: true,
        getValue: (contact) => contact.role,
    },
    {
        field_name: "contact_email",
        label: "email",
        sortable: true,
        getValue: (contact) => contact.contact_email,
    },
    {
        field_name: "phone_number",
        label: "phone-number",
        sortable: false,
        getValue: (contact) => contact.phone_number,
    }
];

export const ORGANISATION_RUBRICS_MODULE = 'ORGANISATION_RUBRICS_MODULE';
export const ORGANISATION_TRIP_MODULE = 'ORGANISATION_TRIP_MODULE';

const locales_cpy: { [key: string]: any } = locales;
export const SUB_NETWORK_LIST_FIELD: OrganisationSubNetworkListField[] = [
    {
        field_name: "name",
        label: "name",
        sortable: true,
        getValue: (sub_network) => sub_network.name || '-',
    }, {
        field_name: "external_code",
        label: "external-code",
        sortable: true,
        getValue: (sub_network) => sub_network.external_code || '-',
    },
    {
        field_name: "created_date",
        label: "created-date",
        sortable: true,
        getValue: (sub_network) => sub_network.modified_date !== null ? format(new Date(sub_network.modified_date), 'P HH:mm', { locale: locales_cpy[i18next.language.replace("-", "")] }) : '-',
    },
    {
        field_name: "creator",
        label: "created-by",
        sortable: true,
        getValue: (sub_network) => `${sub_network.creator ? sub_network.creator.username : '-'}`,
    },
    {
        field_name: "modified_date",
        label: "modified-date",
        sortable: true,
        getValue: (sub_network) => sub_network.modified_date !== null ? format(new Date(sub_network.modified_date), 'P HH:mm', { locale: locales_cpy[i18next.language.replace("-", "")] }) : '-',
    }
];

export const ORGANISATION_TRIP_COLUMN: (keyof OrganisationHistTrip)[] = ['status', 'name', 'destination', 'start_date', 'total_cost', 'accounting_reference'];

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];
export const EMPTY_TRIP_LIST_CONFIGURATION: OrganisationTripListConfiguration = {
    columns: domain === 'tripmci' ? MCI_COLUMN : subDomain === 'marcovasco' ? MV_COLUMN : subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites' || subDomain === 'terres-lointaines' ? CDV_COLUMN : subDomain === 'beachcomber' || subDomain === 'verdie-voyages' ? BEACHCOMBER_COLUMN : DEFAULT_COLUMN,
    preferences: []
};

export const EMPTY_TRIP_LIST_FILTERS: OrganisationTripListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    status: [],
    event: null,
    folder_type: 'ALL',
    folder_initiated_type: 'ALL',
    for_user: null,
    contact_traveler: '',
    pax: 0,
    destination: null,
    user_ta: null,
    user_to: null
};

export const EMPTY_TRIP_LIST_CRITERIA: OrganisationTripListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    search: '',
    filters: EMPTY_TRIP_LIST_FILTERS
};